<template>
    <div>
        <el-row>
            <el-col :span="2" style="font-size:28px; text-align: center; padding-top: 19px">
                <el-tooltip class="item" effect="dark" content="返回上一级页面" placement="bottom-start" :disabled="showTooltip">
                    <i class="el-icon-arrow-left" @click="onBack" style="cursor: pointer"></i>
                </el-tooltip>
            </el-col>
            <el-col :span="12">
                <h3><span v-show="!create">修改配置文件</span><span v-show="create">新增配置文件</span></h3>
            </el-col>
        </el-row>
        <div style="max-width: 800px">
            <el-form ref="form" :model="form" :rules="formRules" label-width="180px" v-loading="showLoading">
                <el-row>
                    <el-form-item label="配置文件名称" prop="configKey">
                        <el-input ref="ipt01" v-model="form.configKey" placeholder="请输入" maxlength="50" show-word-limit
                            :disabled="!create"></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="配置文件信息" prop="configValue">
                            <el-input ref="ipt02" v-model="form.configValue" placeholder="请输入" maxlength="200" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="备注" prop="remark">
                            <el-input ref="ipt03" type="textarea" :rows="3" v-model="form.remark" placeholder="请输入" maxlength="200" show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>   
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="有效标志" prop="isValid">
                            <el-select v-model="form.isValid">
                                <el-option label="是 " value="Y"></el-option>
                                <el-option label="否" value="N"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>             
                <el-form-item>
                    <el-button type="primary" size="small" @click="onSave" v-loading="showBtnLoading">确定</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
   // import _ from "lodash"

    let _kits, _form
    export default {
        props: ["entity"],
        data() {
            var checkConfigKey = (rule, value, callback) => {
                const reg = /^[0-9A-Za-z._]*$/;
                if (!reg.test(value)) {
                    callback(new Error("配置文件名称只能是数字、字母、点和下划线组成"));
                } else {
                    callback();
                }
            };
            
            let create = !this.entity.configKey
            let form
            if (create) {
                form = {
                    configKey: "",
                    configValue: "",
                    reamrk: "",
                    isValid: "Y"
                }
            } else {
                form = Object.assign({}, this.entity)
                console.log(this.entity)
            }
            let data = {
                showLoading: true,
                showTooltip: false,
                showBtnLoading: false,
                create,
                einvtypeCodeOptions: [],
                form,
                formRules: {
                    configKey: [{
                            required: true,
                            message: "请输入配置文件名称",
                            trigger: "blur"
                        }, {
                            validator: checkConfigKey,
                            trigger: "blur"
                        },
                        {
                            max: 50,
                            message: "最多50个字符",
                            trigger: "blur"
                        }
                    ],
                    configValue: [{
                            required: true,
                            message: "请输入配置文件信息",
                            trigger: "blur"
                        },
                        {
                            max: 200,
                            message: "最多200个字符",
                            trigger: "blur"
                        }
                    ],
                    isValid: [{
                        required: true,
                        message: "请选择有效标志",
                        trigger: "blur"
                    }]
                }
            }
            console.log("data is ", data)
            return data
        },
        methods: {
            onBack() {
                this.$emit("back")
            },
            onSave() {
                _form.submit()
            },
        },
        created() {
            _kits = this.$kits();
        },
        mounted() {
            _form = _kits.control.getStandardForm({
                name: "form",
                api: this.create ? "ADDSYSCONFIGDETAILS" : "UPDATESYSCONFIGDETAILS"
            })
            //*
            setTimeout(() => {
                _kits.page.foucus("ipt01")
                this.showLoading = false
                this.showTooltip = true
            }, 300)
            //*/
        }
    }
</script>
